import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'
import { Modal as AntdModal } from 'antd'
import Button from 'components/patterns/Button'
import { isFunction } from 'utils/types'
import { ModalSizes } from './Modal'

export const StyledModal = styled(AntdModal)`
  .danger-modal,
  .pl-dialog-modal,
  .warning-modal {
    width: 437px !important;
  }

  .ant-modal {
    font-family: Arial, sans-serif;
    color: ${themeColor('antModal')};
  }

  .ant-modal-content {
    position: relative;
    background-color: ${themeColor('headerColorWhite')};
    background-clip: padding-box;
    border: 0;
    border-radius: 4px;
    pointer-events: auto;
    padding: 0px;
  }

  .ant-modal-body {
    padding: 24px;
    font-size: 14px;
    word-wrap: break-word;
  }
  .warning-modal,
  .danger-modal {
    width: 437px !important;
  }

  .ant-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 25px;
    border-bottom: 1px solid ${themeColor('grey')};
    color: ${themeColor('modalHeaderColor')};
    background: ${themeColor('headerColorWhite')};
    border-radius: 4px 4px 0 0;
  }

  .ant-modal-body {
    padding: 24px;
    font-size: 14px;
    line-height: 1.5;
    background: var(--Grey-Modal-Grey, #fbfbfb);
  }

  .ant-modal-footer {
    padding: 10px 16px;
    text-align: right;
    background: transparent;
    border-radius: 0 0 4px 4px;
    border-top: 1px solid ${themeColor('grey')};
  }

  .ant-btn,
  .ant-btn:active,
  .ant-btn:focus {
    outline: 0;
  }
  .ant-modal-footer button + button {
    margin-bottom: 0;
    margin-left: 8px;
  }
  .batch-import-modal .ant-modal-header {
    border-bottom: 1px solid ${themeColor('modalHeaderBottomBorder')};
  }

  .ant-modal-body p:last-child {
    margin-bottom: 0px;
  }

  .ant-btn-primary {
    border: 0px;
  }

  .ant-btn-primary[disabled] {
    text-shadow: none;
    box-shadow: none;
  }

  .info-black-icon {
    height: 20px;
    width: 20px;
    background: url('../img/info-black-icon.svg') no-repeat;
  }

  .anticon svg {
    display: inline-block;
  }

  .modal-header-icon {
    font-size: 24px;
    margin-right: 10px;
    vertical-align: text-bottom;
  }
  .warning-modal-icon,
  .warning-modal .ant-modal-title::before {
    color: ${themeColor('warningModalIcon')};
    height: 24px;
    width: 24px;
    display: inline-block;
    font-size: 24px;
  }

  .pl-dialog-modal .ant-modal-title,
  .warning-modal .ant-modal-title,
  .danger-modal .ant-modal-title {
    line-height: 24px;
  }

  .pl-dialog-modal .ant-modal-title::before,
  .warning-modal .ant-modal-title::before,
  .danger-modal .ant-modal-title::before {
    margin-right: 16px;
  }

  .chec-icon--question-circle {
    cursor: default;
    position: relative;
    top: -4px;
    left: -4px;
  }

  .chec-error-modal .button_text {
    text-transform: capitalize;
  }

  .ant-modal-content .hidden {
    display: none;
  }

  .ant-modal-content .close-icon {
    margin: 20px;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
    display: none;
  }

  .ant-modal-content .close-icon.show {
    display: block;
  }

  .chec-error-modal .ant-modal-title {
    display: flex;
    align-items: center;
  }
  .chec-error-modal .ant-modal-title h2 {
    display: inline-block;
  }

  .ant-modal-title {
    font-family: Arial, sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: normal;
    text-align: left;
    color: rgba(7, 7, 15, 0.87);
  }

  .ant-modal-close {
    top: 16px;
    right: 25px;
  }

  .ant-modal-close-x {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    font-size: 20px;
    line-height: 20px;
    color: rgba(7, 7, 15, 0.87);
  }
`
export const FooterStyling = styled.div`
  display: 'flex';
  justifycontent: 'center';
`
export const Link = styled.span`
  color: #0051c4;
  text-decoration: none;
  cursor: pointer;
`
export const WaringModal = styled.div`
  width: 437px !important;
`

export const ModalBounds = styled.div((props) => {
  const sizes = {
    [ModalSizes.XL]: '1200px',
    [ModalSizes.L]: '964px',
    [ModalSizes.M]: '640px',
    [ModalSizes.S]: '480px',
    [undefined]: '480px',
    any: props.width || '480px',
  }
  const size = isFunction(props.size) ? props.size() : sizes[props.size]

  return `
  display: flex;
  width: ${size};
  padding: 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  

  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: ${themeColor('modalGrey')(props)};
`
})

export const ModalOverlay = styled.div`
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background: ${themeColor('shadow')};
  z-index: 10000;
`

export const ModalHeaderLayout = styled.div`
  display: flex;
  height: auto;
  padding: 16px 25px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-radius: 3px 3px 0px 0px;
  border-bottom: 1px solid ${themeColor('grey')};
  background: ${themeColor('whitePrimary')};

  > svg {
    margin-right: 16px;
    height: 20px;
    width: 20px;
    vertical-align: bottom;
    margin-bottom: 2px;
  }
`

export const ModalBodyLayout = styled.div`
  display: flex;
  height: 100%;
  padding: 0;
  align-items: flex-start;
  align-self: stretch;
`

export const ModalContainerLayout = styled.div`
  display: flex;
  height: 100%;
  padding: 0;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`

export const ModalContentContainerLayout = styled.div`
  height: 100%;
  padding: 25px;
  overflow: auto;
  background-color: var(--Grey-Modal-Grey, #fbfbfb);
  flex: 1;
  max-height: calc(80vh - 200px);
  width: 100%;
`

export const ModalSideContainerLayout = styled.div`
  display: flex;
  height: 100%;
  width: 280px;
  padding: 0;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-left: 1px solid ${themeColor('grey')};
  background: ${themeColor('whitePrimary')};
  overflow: auto;
`

export const ModalFooterLayout = styled.div`
  display: flex;
  height: auto;
  padding: 16px 25px;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  border-top: 1px solid ${themeColor('grey')};
  background: ${themeColor('whitePrimary')};
`

export const ModalMainContainer = styled.div`
  display: flex;
  height: 100%;
  padding: 0;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  flex: 1;
`

export const ModalBannerLayout = styled.div`
  padding: 25px;
  align-self: stretch;
  > div {
    margin: 0;
  }
`

export const ModalCloseButtonLayout = styled(Button)`
  && {
    padding: 0;
    background: none;
    margin: 0;
    border: none;
    box-shadow: none;
    width: 14px;
    height: 14px;
    &:hover {
      background: none;
    }

    svg {
      margin: 0;
      fill: ${themeColor('blackPrimary')};
      width: 100%;
      height: 100%;
    }
  }
`
